import { HsControlActionType } from '@lib/core-ts/tools-new/actions/control-action-type.enum';

export const KEY_MAP: Map<string, HsControlActionType> = new Map([
  ['ArrowUp', HsControlActionType.PressedTop],
  ['w', HsControlActionType.PressedTop],
  ['ц', HsControlActionType.PressedTop],

  ['ArrowDown', HsControlActionType.PressedBottom],
  ['s', HsControlActionType.PressedBottom],
  ['ы', HsControlActionType.PressedBottom],

  ['ArrowLeft', HsControlActionType.PressedLeft],
  ['a', HsControlActionType.PressedLeft],
  ['ф', HsControlActionType.PressedLeft],

  ['ArrowRight', HsControlActionType.PressedRight],
  ['d', HsControlActionType.PressedRight],
  ['в', HsControlActionType.PressedRight],

  ['+', HsControlActionType.PressedPlus],
  ['-', HsControlActionType.PressedMinus],

  ['Control', HsControlActionType.PressedCtrl],
  ['Shift', HsControlActionType.PressedShift],

  ['q', HsControlActionType.PressedAdditionalOne],
  ['e', HsControlActionType.PressedAdditionalTwo],
  ['й', HsControlActionType.PressedAdditionalOne],
  ['у', HsControlActionType.PressedAdditionalTwo],
]);
